<template>
  <div
    class="crop-upload"
    :class="canedit ? '' : 'disabled'"
    :style="{
      width: avatarStyle.width,
    }"
  >
    <div
      class="crop-u-view"
      @click="clickImg"
    >
      <div v-if="loadErr">
        <img
          v-if="placeholder"
          :src="placeholder"
          class="avatar"
          :style="{
            width: avatarStyle.width,
            height: avatarStyle.height,
            borderRadius: avatarStyle.radius,
          }"
        >
        <img
          v-else
          src="../../../assets/image/icon_default_school_pray.png"
          class="avatar"
        >
      </div>
      <img
        v-else
        :src="cp_src"
        class="avatar"
        @error="loadFail"
      >
      <div
        v-if="canedit"
        class="posi-handler"
      >
        <i
          class="el-icon-view"
          @click.stop="previewEvent"
        />
        <!--<i class="el-icon-delete" @click.stop="reSet"></i>-->
      </div>
    </div>

    <upload-avatar
      ref="crop"
      v-model="dialogVisible"
      field="img"
      title="上传LOGO"
      :width="200"
      :height="200"
      :url="uploadAction"
      :params="data"
      :headers="headers"
      :max-size="maxSize"
      img-format="png"
      @src-file-set="srcFileSet"
      @crop-success="cropSuccess"
    />

    <transition name="pro-fade">
      <el-progress
        v-show="progress.show"
        ref="progress"
        class="crop-process"
        :width="90"
        type="circle"
        :percentage="progress.val"
        color="#2ED095"
      />
    </transition>
  </div>
</template>

<script>
import UploadAvatar from './UploadAvatar';

export default {
    name: 'UploadImg',
    components: { UploadAvatar },
    props: {
        src: {
            type: String,
            default: '',
        },
        canedit: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
        // 单文件大小限制
        maxSize: {
            type: Number,
            default: 1024,
        },
        avatarStyle: {
            type: Object,
            default: () => ({
                width: '80px',
                height: '80px',
                radius: '50%',
            }),
        },
    },
    data () {
        return {
            uploadAction: '', // 上传地址
            fileInfo: {
                name: '',
                file_md5: '',
                file_name: '',
                user_id: '',
                mo_authority_token: '',
                raw: '',
            },
            dialogVisible: false,
            data: {},
            headers: {},
            progress: {
                val: 0,
                show: false,
            },
            fileUrl: '',
            downloadUrl: '',
            upload: {
                ali_finish_url: '',
            },
            tempIndex: 1,
            loadErr: false,
            defaultSrc: '',
        };
    },
    computed: {
        cp_src () {
            return this.src || '';
        },
    },
    watch: {
        src: {
            handler (val) {
                if (!this.defaultSrc) {
                    this.defaultSrc = val;
                }
                this.loadErr = false;
            },
        },
    },

    mounted () {
        this.$refs.progress && document.body.appendChild(this.$refs.progress.$el);
    },

    destroyed () {
        let el = this.$refs.progress && this.$refs.progress.$el;
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    },
    methods: {
    /* 选中图片后 */
        srcFileSet (name, type, size) {
            this.fileInfo.name = name;
            // const isJPG = ['image/jpeg', 'image/png'].includes(type);
            // const isLt2M = size / 1024 / 1024 < 2;
            // this.fileInfo.name = name;
            // if (!isJPG) {
            //     this.$message.error('上传头像图片只能是 JPG后PNG 格式!');
            // }
            // if (!isLt2M) {
            //     this.$message.error('上传头像图片大小不能超过 2MB!');
            // }
            // return isJPG && isLt2M;
        },
        /* 确认裁剪后 */
        cropSuccess (base64, type) {
            let option = {
                onFail: this.onError,
                onSucc: this.handleAvatarSuccess,
                onProgress: this.onProgress,
            };
            Object.assign(this.progress, {
                show: true,
                val: 0,
            });
            try {
                window.yxpupload.base64Upload(base64, this.fileInfo.name, option);
            } catch (e) {
                this.$message.error('系统出错！');
                this.onError();
            }
        },

        /* 上传成功 */
        handleAvatarSuccess (data) {
            this.downloadUrl = data.downUrl;
            this.fileUrl = data.url;
            this.$emit('upload-success', {
                downloadUrl: this.downloadUrl,
                fileUrl: this.fileUrl,
                filePath: data.result.filePath,
            });
            this.hiddenProcess();
        },
        /* 上传失败 */
        onError () {
            Object.assign(this.progress, {
                show: false,
            });
        },
        /* 预览图片 */
        previewEvent () {
            if (!this.src) return this.$message.error('暂无图片');
            window.yxp_preview_img = this.src;
            window.open(window.yxpapi.store.getters['runEnv/baseUrl'] + '/yxp-ebag/plugins/preview.html');
        },
        /* 还原图片 */
        reSet () {
            this.$confirm('确认删除图片?', '提示', {
                confirmButtonText: '确定',
                closeOnClickModal: false,
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$emit('upload-success', {
                    fileUrl: this.defaultSrc,
                });
            }).catch(() => {});
        },
        onProgress (e) {
            Object.assign(this.progress, {
                val: Math.round(e.progress),
            });
        },
        hiddenProcess () {
            Object.assign(this.progress, {
                val: 100,
            });
            setTimeout(() => {
                Object.assign(this.progress, {
                    show: false,
                });
                this.$refs.crop.off();
                this.uploadAction = '';
            }, 1000);
        },
        loadFail () {
            this.loadErr = true;
        },
        clickImg () {
            if (this.canedit) {
                this.dialogVisible = true;
            }
        },
    },
};
</script>

<style scoped lang="scss">
  @import "../../../sass/theme.scss";

  .pro-fade-leave-active {
    transition: all .5s ease;
  }
  .pro-fade-leave-to {
    opacity: 0;
  }
  .el-progress {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10001;
  }
  .crop-upload {
    display: inline-block;
    width: 80px;
    height: 80px;
    overflow: hidden;
    cursor: pointer;
    &.disabled {
        cursor: not-allowed;
    }
    .crop-u-view {
      position: relative;
      display: inline-block;
      height: 80px;
      &:hover {
        .posi-handler {
          display: block;
          bottom: 0;
        }
      }
    }
    .posi-handler {
      position: absolute;
      bottom: -30px;
      left: 0;
      height: 30px;
      width: 100%;
      background: rgba(150, 150, 150, .6);
      color: #fff;
      text-align: center;
      -webkit-transition: bottom .2s linear;
      -moz-transition: bottom .2s linear;
      -ms-transition: bottom .2s linear;
      -o-transition: bottom .2s linear;
      transition: bottom .2s linear;
      [class^=el-icon] {
        padding: 5px;
        font-size: 1.2rem;
        cursor: pointer;
        &:hover {
          color: $primary;
        }
      }
    }
  }

  .avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  .avatar-uploader {
    display: none;
  }
</style>

<style lang="scss">

  .crop-process {
    .el-progress-circle {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
    }
  }
</style>
